import { useState, useRef, useEffect } from "react";
const SUPPORT_EVENT_TYPES = [
  "data-events-connected",
  "data-live-takeover-state",
  "data-human-reply",
  "data-live-takeover-started",
  "data-live-takeover-ended",
  "data-takeover-team-changed",
  "data-ticket-status-updated",
  "data-user-message-mirrored",
  "data-user-message-delivery-failed"
];
const DEFAULT_BASE_URL = "";
function useConciergeSupportEvents(conversationId, apiBaseUrl, onReconnect) {
  const [liveParts, setLiveParts] = useState([]);
  const onReconnectRef = useRef(onReconnect);
  useEffect(() => {
    onReconnectRef.current = onReconnect;
  }, [onReconnect]);
  useEffect(() => {
    if (!conversationId) {
      setLiveParts([]);
      return;
    }
    const baseUrl = apiBaseUrl ?? DEFAULT_BASE_URL;
    const url = `${baseUrl}/api-rewards/concierge/support/conversation/${encodeURIComponent(
      conversationId
    )}/events`;
    let es = null;
    try {
      es = new EventSource(url, { withCredentials: true });
    } catch (err) {
      console.warn("Failed to open support events SSE", err);
      return;
    }
    let connectCount = 0;
    const listeners = [];
    for (const type of SUPPORT_EVENT_TYPES) {
      const fn = (msg) => {
        var _a;
        try {
          const data = msg.data ? JSON.parse(msg.data) : void 0;
          setLiveParts((prev) => [...prev, { type, data }]);
          if (type === "data-events-connected") {
            connectCount += 1;
            if (connectCount >= 2) {
              try {
                (_a = onReconnectRef.current) == null ? void 0 : _a.call(onReconnectRef);
              } catch (err) {
                console.warn("onReconnect handler threw", err);
              }
            }
          }
        } catch (err) {
          console.warn("Failed to parse support event payload", { type, err });
        }
      };
      es.addEventListener(type, fn);
      listeners.push({ type, fn });
    }
    return () => {
      for (const { type, fn } of listeners) {
        es == null ? void 0 : es.removeEventListener(type, fn);
      }
      es == null ? void 0 : es.close();
    };
  }, [conversationId, apiBaseUrl]);
  return liveParts;
}
export {
  useConciergeSupportEvents
};
//# sourceMappingURL=useConciergeSupportEvents.js.map
